import { render } from "./MyComments.vue?vue&type=template&id=640f8100&scoped=true"
import script from "./MyComments.vue?vue&type=script&lang=js"
export * from "./MyComments.vue?vue&type=script&lang=js"

import "./MyComments.vue?vue&type=style&index=0&id=640f8100&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640f8100"]])

export default __exports__